// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"651":"3157f8df6090560f","736":"8811b46c894d648e","741":"1461f8579c99c4ea","943":"fe121f16336e73e3"}[chunkId] + ".js";
};